import React, { FC } from 'react';
import cls from './WeeksModeBody.module.css';
import classNames from 'classnames';
import { WeeksModeStage } from './WeeksModeStage/WeeksModeStage';

export const WeeksModeBody = ({ stages }) => {
    return (
        <div className={classNames(cls.DaysModeBody)}>
            {stages.map((stage) => (
                <WeeksModeStage key={stage.id} stage={stage} />
            ))}
        </div>
    );
};
